import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import swal from 'sweetalert2';        

@Component({
  selector: 'app-ticket',
  templateUrl: './ticket.component.html',
  styleUrls: ['./ticket.component.scss']
})
export class TicketComponent implements OnInit {

  constructor(  public authService: AuthService,
    public router: Router) { }

  ngOnInit() {
  this.ls_ticket();
  this.ls_modulos();
  }
  bndmnugral=true;
  oculta_menu(){
    console.log("-");
    if(this.bndmnugral==true){
      this.bndmnugral=false;
    }else{
      this.bndmnugral=true;
    }
    console.log(this.bndmnugral);
  }
  can_ticket(){
    this.bndEditticket=true;
  }
  id_modulo=0;
  asignado_a=0;
  des_ticket="";
  estatus="";
  gda_ticket(){
    if(this.id_modulo==0)return;
    if(this.des_ticket.length==0)return;
    let data={
      id_usuario:Number(localStorage.getItem("usuario")),
      id_cliente:Number(localStorage.getItem("cliente")),
      id_modulo:this.id_modulo,
      descripcion:this.des_ticket
    };
    console.log(data)
    this.authService.service("/api/gda_ticket",data).then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);
        this.ls_ticket();
      },
      error => {
        console.log(error);
      });
  }
  loading;
  modulos=[];
  org_;
  ls_modulos(){
    let postData={
    };    
    this.loading=true;    
    this.authService.service("/api/permisos",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);         
        this.loading=false;
        this.modulos=data;
        console.log(data)
        
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          this.loading=false;
          swal.fire('¡API incorrecta..! ls_usuarios', '', 'error');
    }); 
  }

  id_ticket=0;
  det_ticket=[];
  vdet_ticket(itm){
    this.id_ticket=itm.id;
    let postData={
      id_ticket:itm.id
    }
    this.authService.service("/api/get_detticket",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);         
        this.loading=false;
        this.det_ticket=data;        
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          this.loading=false;
          swal.fire('¡API incorrecta..! ls_usuarios', '', 'error');
    }); 
  }
  upd_ticket(){
    let data={
      id:this.id_ticket,
      estatus:this.estatus
    };
    console.log(data);
    this.authService.service("/api/upd_ticket",data).then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);
        this.ls_ticket();
        swal.fire('ok', '', 'success');
      },
      error => {
        console.log(error);
      });
  }
  asigna_ticket(){
    let data={
      id:this.id_ticket,
      asignado_a:this.asignado_a
    };
    this.authService.service("/api/asigna_ticket",data).then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);
        this.ls_ticket();
      },
      error => {
        console.log(error);
      });
  }
  ticket=[];
  nvo_ticket(){
    this.des_ticket="";
    this.id_modulo=0
    this.bndEditticket=false;
  }
  editar_t(itm){
    this.id_ticket=itm.id;
    this.estatus=itm.estatus;
    this.bndEditticket=true;
  }
  bndEditticket=false;
  ls_ticket(){
    this.ticket=[]
    let data={
      id_usuario:localStorage.getItem("usuario"),
      id_cliente:localStorage.getItem("id_cliente")

    };
    this.authService.service("/api/get_ticket",data).then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);
        this.ticket= res;
      },
      error => {
        console.log(error);
      });

  }
}
